module.exports = __webpack_public_path__ + "static/media/photo66.3ed390e2.jpg";